import { Card, CardContent, CardHeader } from "@mui/material"
import { CommonConstant } from "shared/constants/common-constant"
import { Link, useNavigate } from "react-router-dom"
import { formatDisplayDate } from "utils/date-helper"
import { useStores } from "stores/root-store"
import { CommonHyperlink, CustomDataGrid } from "components/common-styles"
import { useEffect, useState } from "react"
import { format } from "date-fns"
import { GridToolbarContainer } from "@mui/x-data-grid"
import CustomExportButton from "components/common/custom-export-button"

function CustomToolbarAsn(props) {
  return (
    <GridToolbarContainer>
      <CustomExportButton exportOptions={props.exportOptions} />
    </GridToolbarContainer>
  )
}

const InboundDeliveryProductInfo = () => {
  const navigate = useNavigate()
  const { InboundDeliveryStore } = useStores()
  const products = [...InboundDeliveryStore.products]
  const [exportFileName, setExportFileName] = useState("")

  const handleCellClicked = params => {
    if (params.field === "product") {
      navigate(`/products/${encodeURIComponent(params.row["product"])}`)
    }
  }

  const columns = [
    {
      field: "line_num",
      headerName: "Line No.",
      renderCell: params => Number(params.value).toFixed(3),
    },
    {
      field: "product",
      headerName: "Product",
      minWidth: 200,
      flex: 1,
      renderCell: params => <CommonHyperlink>{params.value}</CommonHyperlink>,
    },
    {
      field: "product_description",
      headerName: "Description",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "item_category1",
      headerName: "Item Category 1",
    },
    {
      field: "item_category2",
      headerName: "Item Category 2",
    },
    {
      field: "item_category3",
      headerName: "Item Category 3",
    },
    {
      field: "expected_quantity",
      headerName: "Expected Qty",
      type: "number",
    },
    {
      field: "receipted_quantity",
      headerName: "Receipted Qty",
      type: "number",
    },
    {
      field: "item_length",
      headerName: "Length (M)",
      type: "number",
    },
    {
      field: "item_width",
      headerName: "Width (M)",
      type: "number",
    },
    {
      field: "item_height",
      headerName: "Height (M)",
      type: "number",
    },
    {
      field: "item_weight",
      headerName: "Weight (KG)",
      type: "number",
    },
    {
      field: "serial_capture",
      headerName: "Serial Capture",
    },
    {
      field: "lot_controlled",
      headerName: "Lot Controlled",
    },
    {
      field: "lot",
      headerName: "Batch",
    },
    {
      field: "expiry",
      headerName: "Expiry",
      width: 120,
      renderCell: params => {
        return params.value ? formatDisplayDate(params.value) : ""
      },
    },
    {
      field: "last_update_datetime",
      headerName: "Last Update Date",
      width: 120,
      renderCell: params => {
        return formatDisplayDate(params.value)
      },
    },
  ]

  useEffect(() => {
    const pathNames = location.hash.split("/").filter(x => x && x != "#")
    const receiptId = decodeURIComponent(pathNames.length > 1 ? pathNames[1] : "")
    setExportFileName(`Express_Inbound_Product.${receiptId}-${format(new Date(), "ddMMyyyy.HHmm")}`)
  }, [])

  return (
    <Card id="cardProducts">
      <CardHeader title="Product Information" />
      <CardContent>
        {!products || products.length == 0 ? (
          <></>
        ) : (
          <CustomDataGrid
            getRowId={row => row.line_id}
            rows={products.filter(x => x.action !== "DELETE")}
            columns={columns}
            initialState={{
              sorting: {
                sortModel: [{ field: "line_num", sort: CommonConstant.ASCENDING }],
              },
              pagination: {
                paginationModel: {
                  pageSize: 15,
                },
              },
            }}
            pageSizeOptions={[10, 15, 20, 50]}
            onCellClick={handleCellClicked}
            slots={{
              toolbar: CustomToolbarAsn,
            }}
            slotProps={{
              toolbar: {
                exportOptions: { hiddenColumns: {}, columns: columns, fileName: exportFileName, data: products.filter(x => x.action !== "DELETE") },
              },
            }}
          />
        )}
      </CardContent>
    </Card>
  )
}

export default InboundDeliveryProductInfo
